module.exports = __webpack_public_path__ + "static/media/MzCare_Logo_white.c14ede8c.svg";